module.exports = __webpack_public_path__ + "static/media/icon_massage.f7e76263.svg";